export const REQUEST_DELAY = 2000;
export const LANGUAGE = 'ES';

export const BASE_URL = 'https://testigoselectorales.herokuapp.com';
export const CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/miratestigoselectorales/image/upload';

export const DOCUMENT_TYPE = {
  e14: "E14",
  votes: "CuentaVotos",
  claim: "Reclamaciones",
}; 

export const CORPORATION = {
  SENADO: 'Senado',
  CAMARA: 'Camara',
  CONSULTA: 'Consulta',
};

export const PATHS = {
  DASHBOARD: '/dashboard',
  LOGIN: '/',
};

export const CAMERA_ERRORS = {
  NOT_AVAILABLE: "NOT_AVAILABLE",
  NOT_ALLOWED: "NotAllowedError"
};
